
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import OrganizationIntro from './components/OrganizationIntro';
import ProjectTimeline from './components/ProjectTimeline';
import ContactInfo from './components/ContactInfo';
import MediaReports from './components/MediaReports';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[300px] md:h-[500px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=Charity%20organization%20team%20group%20photo%20with%20volunteers%20and%20staff%20members%20working%20together%20in%20modern%20office%20environment%2C%20warm%20atmosphere%20showing%20unity%20and%20dedication%20to%20public%20welfare%2C%20professional%20team%20portrait%20with%20diverse%20people%20smiling%2C%20bright%20natural%20lighting%2C%20inspirational%20nonprofit%20organization%20scene&width=1920&height=500&seq=about-hero-bg&orientation=landscape)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-3xl md:text-5xl font-bold mb-3 md:mb-4">关于我们</h1>
          <p className="text-sm md:text-xl max-w-2xl mx-auto">用心做公益，用爱传温暖</p>
        </div>
      </section>

      <OrganizationIntro />
      <ProjectTimeline />
      <ContactInfo />
      <MediaReports />
      
      <Footer />
    </div>
  );
}
